import { render, staticRenderFns } from "./BlocksList.vue?vue&type=template&id=2394399e&scoped=true&"
import script from "./BlocksList.vue?vue&type=script&lang=js&"
export * from "./BlocksList.vue?vue&type=script&lang=js&"
import style0 from "./BlocksList.vue?vue&type=style&index=0&id=2394399e&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2394399e",
  null
  
)

export default component.exports